export const sortFields = ['name'] as const;
